import { useState } from "react";
import { IconButton, Paper, styled } from "@mui/material";
import { Close, Search } from "@mui/icons-material";

import { useTranslation } from "react-i18next";
import { Field, Form, Formik, FormikHelpers } from "formik";
import { InputBase } from "formik-mui";

import { SearchForm } from "../../../types";
import { LayersSearchDebouncedSubmit } from "./LayersSearchDebouncedSubmit";

interface Props {
  search: string;
  className?: string;
  setSearch: (value: string) => void;
  setInputRef?: (ref: HTMLInputElement) => void;
}

export function IndicatorSearch(props: Props) {
  const { search, setSearch, className, setInputRef } = props;
  const { t } = useTranslation();
  const [elevation, setElevation] = useState(0);

  const initialValues = { search: search };

  async function onSubmit(
    values: SearchForm,
    helpers: FormikHelpers<SearchForm>
  ) {
    const { setSubmitting } = helpers;
    setSubmitting(true);
    setSearch(values.search.trim());
  }

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ submitForm, values, dirty, setFieldValue }) => (
        <Form>
          <Styles elevation={elevation} className={className}>
            <LayersSearchDebouncedSubmit
              submitForm={submitForm}
              values={values}
              dirty={dirty}
            />
            <Field
              component={InputBase}
              name="search"
              type="search"
              id="search-field"
              inputRef={setInputRef}
              placeholder={t("label.searchIndicator")}
              onFocus={() => setElevation(4)}
              disabled={false}
              onBlur={() => setElevation(0)}
              autoComplete="off"
            />

            {!search && (
              <IconButton type="submit">
                <Search />
              </IconButton>
            )}
            {search && (
              <IconButton
                onClick={() => {
                  setFieldValue("search", "", false);
                  setSearch("");
                }}
              >
                <Close />
              </IconButton>
            )}
          </Styles>
        </Form>
      )}
    </Formik>
  );
}

const Styles = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(0.5, 1)};
  display: flex;
  align-content: center;

  form {
    display: flex;
    flex-wrap: nowrap;
  }

  .MuiInputBase-root {
    color: ${({ theme }) => theme.palette.common.white};
    margin-right: ${({ theme }) => theme.spacing(1)};
  }

  #search-field::-webkit-search-cancel-button {
    display: none;
  }
`;
